import Uuid from '__utils/uuid/@1.0';
import { AxiosFactory } from 'emrn-api/AxiosFactory';
import { getRequestId } from 'emrn-api/getRequestId';
import { Platform } from 'react-native';
import { PzptApiOptions } from './PzptApiOptions';

class PzptApiAxiosRequest extends AxiosFactory {
  constructor() {
    super('PzptApiAxiosRequest');
    this.fetch = this.fetch.bind(this);
  }

  /**
   * 获取接口数据
   * @param url 请求地址
   * @param data 请求数据
   * @param options 请求配置
   * @returns
   */
  async fetch<ResponseT>(url: string, data: object, options: PzptApiOptions = {}) {
    const requestId = getRequestId(new Date(), 32);
    data = {
      args: data,
      client: Platform.OS,
      randomCode: Uuid(16),
      timestamp: new Date().getTime(),
      reserve: requestId,
    };

    url = `${url}${url.includes('?') ? '&' : '?'}rd=${requestId}`;

    const axios2Res = await this.axios2<ResponseT>(
      {
        url,
        data,
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
      },
      { requestId, ...options }
    );

    return axios2Res.data;
  }
}

/**
 * 大赛配置接口请求类`单例`对象
 */
export const PzptApi = new PzptApiAxiosRequest();
